import React, { Fragment } from "react";
import { Alert, Col, Row, Typography } from "antd";
import { BulbOutlined, CheckCircleOutlined, SyncOutlined, WarningOutlined } from "@ant-design/icons";
import CustomCard from "../extraShit/CustomCard";
import { useTranslation } from "react-i18next";
import GamePage from "./GamePage";
import "./gameContent.css";

const { Paragraph } = Typography;

const RageCage: React.FC = () => {
    const { t } = useTranslation();
    const setupImageMeta = t("games.details.rageCage.setupImages", { returnObjects: true }) as Array<{ alt: string; caption: string }>;
    const steps = t("games.details.rageCage.steps", { returnObjects: true }) as Array<{ note?: string }>;
    const setupImages = [
        { ...setupImageMeta[0], src: `${process.env.PUBLIC_URL ?? ""}/cards/RageCageSetup.png` },
        { ...setupImageMeta[1], src: `${process.env.PUBLIC_URL ?? ""}/cards/RageCageSetupBeWild.png` },
    ];

    return (
        <GamePage
            game="rageCage"
            tagColor="gold"
            instructionIcons={[
                <CheckCircleOutlined key="start" />,
                <SyncOutlined key="bounce" />,
                <SyncOutlined key="pass" />,
                <WarningOutlined key="overlap" />,
                <BulbOutlined key="middle" />,
            ]}
        >
            <div className="rage-cage">
                <CustomCard title={<h2 className="game-content__title">{t("games.details.rageCage.setupTitle")}</h2>}>
                    <Paragraph>
                        {t("games.details.rageCage.setupDescription").split("\n").map((line, index, lines) => (
                            <Fragment key={`${line}-${index}`}>
                                {line}{index < lines.length - 1 && <br />}
                            </Fragment>
                        ))}
                    </Paragraph>
                    <Row gutter={[18, 18]} justify="center">
                        {setupImages.map(img => (
                            <Col xs={24} sm={12} key={img.alt}>
                                <img className="rage-cage__setup-image" src={img.src} alt={img.alt} />
                                <Paragraph type="secondary" className="rage-cage__caption">{img.caption}</Paragraph>
                            </Col>
                        ))}
                    </Row>
                    <Alert message={t("games.details.rageCage.setupTip")} type="info" showIcon icon={<BulbOutlined />} />
                </CustomCard>
                {steps.some(step => step.note) && (
                    <div className="rage-cage__notes">
                        {steps.filter(step => step.note).map((step, index) => (
                            <Alert key={`${step.note}-${index}`} message={step.note} type="info" showIcon icon={<BulbOutlined />} />
                        ))}
                    </div>
                )}
                <Alert message={t("games.details.rageCage.paceTip")} type="warning" showIcon icon={<WarningOutlined />} />
                <Paragraph type="secondary" className="rage-cage__footer">{t("games.details.rageCage.footer")}</Paragraph>
            </div>
        </GamePage>
    );
};

export default RageCage;
